import { Controller } from "@hotwired/stimulus"

// Sets a progress bar's width from a data value instead of an inline `style`
// attribute, which a strict Content-Security-Policy (style-src 'self' + nonce)
// would drop. Assigning element.style.width via the CSSOM is not gated by CSP.
export default class extends Controller {
  static values = {
    width: { type: Number, default: 0 }
  }

  connect() {
    this.applyWidth()
  }

  widthValueChanged() {
    this.applyWidth()
  }

  applyWidth() {
    const pct = Math.max(0, Math.min(100, this.widthValue))
    this.element.style.width = `${pct}%`
  }
}
